import React from "react";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import { useAuthProvider, getBaseUrl, useSessionId, Loader } from "@cloudpremise/portal_core";
import { useNavigate } from "react-router-dom";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useMsal } from "@azure/msal-react";

// @mui material components
import Grid from "@mui/material/Grid";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    jsforce: any,
}

const Logout = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const { instance } = useMsal();
    const sessionId = useSessionId();
    const navigate = useNavigate();
    React.useEffect(() => {
        const logoutStatus = localStorage.getItem("reactforce_logout");
        if(authType === "microsoft" && logoutStatus === "1"){
            return;
        }
        localStorage.setItem("reactforce_logout", "1");
        logout(() => {
            return navigate("/landing", { replace: true });
        });

        return () => {
            localStorage.removeItem("reactforce_logout");
        }
    });

    const logout = (callback) => {
        switch(authType){
            case 'link':
            case 'google':
            case 'github':
            case 'facebook':
            case 'apple':
                localStorage.removeItem("reactforce_logout");
                localStorage.removeItem("secure_link_key");
                localStorage.removeItem("verified_entity");
                localStorage.removeItem("identity_token");
                localStorage.removeItem("login_type");
                localStorage.removeItem("google_login");
                localStorage.removeItem("github_login");
                localStorage.removeItem("facebook_login");
                localStorage.removeItem("apple_login");
                window.history.replaceState(null, document.title, props.basename+"/landing");
                window.inlineApexAdaptor.sessionId = "";
                callback();
                break;
            case 'microsoft':
                localStorage.removeItem("reactforce_logout");
                localStorage.removeItem("identity_token");
                localStorage.removeItem("verified_entity");
                localStorage.removeItem("login_type");
                callback();
                // instance.logout({
                //     postLogoutRedirectUri: window.origin + getBaseUrl(),
                // });
                break;
            case 'salesforce':
                if(sessionId.length > 0){
                    // Handle it later
                    window.location.href = props.basename+"/secur/logout.jsp";
                    // callback();
                }
                break;
            default:
                break;
        }
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={7} lg={5} py={{ xs: 0, sm: 2 }} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    p={2}
                                    textAlign="left"
                                >
                                    <Loader color="info" />
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default Logout;